/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import { useEffect } from "react";
import axios from "../api/axiosInstance";

export const useLoadReservationData = ({
  reservationIdRef,
  location,
  setCustomerData,
  setGuestChildren,
  setGuestCustomers,
  setFormData,
  activeReservationId,
}) => {
  
  useEffect(() => {
    const reservationId = activeReservationId;
    if (!reservationId) return;

  
    const fetchGuests = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests/by-draft/${reservationId}`
        );
        const allGuests = response.data;

  
        // Main Guest
        const mainGuest = allGuests.find(g => g.is_main_guest);
        if (mainGuest?.customer_id) {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/customers/${mainGuest.customer_id}`);
            console.log("⚠️ setCustomerData ejecutado para reserva", reservationId, "→ Customer:", mainGuest?.customer_id);
            setCustomerData((prev) => {
              return prev?.__manual_insert ? { ...res.data, __manual_insert: true } : res.data;
            });
            
            console.log("✅ Main guest cargado desde DB:", res.data);
          } catch (err) {
            console.warn("⚠️ No se pudo cargar el main guest:", err);
          }
        }
  
        // ✅ Children: respeta el guest_index igual que accompanying
        const childGuests = allGuests.filter(g => g.is_child);
        const rebuiltChildren = [];

        childGuests.forEach(guest => {
          const index = guest.guest_index;
          if (typeof index === "number") {
            rebuiltChildren[index] = guest.customer || guest;
          }
        });

        console.log("🧪 [fetchGuests] reservationId:", reservationId);
        console.log("🧪 [fetchGuests] endpoint:", "/api/reservation-drafts/draft-guests/by-draft/:id");
        console.log("🧪 [fetchGuests] rows:", allGuests);


        setGuestChildren(rebuiltChildren);

  
        // Accompanying Guests
        const accompanyingGuests = allGuests.filter(g => !g.is_main_guest && !g.is_child);
        const rebuiltAccompanying = [];

        accompanyingGuests.forEach(guest => {
          const index = guest.guest_index;
          if (typeof index === "number") {
            rebuiltAccompanying[index] = guest.customer || guest;
          }
        });

        console.log("🧪 [fetchGuests] reservationId:", reservationId);
        console.log("🧪 [fetchGuests] endpoint:", "/api/reservation-drafts/draft-guests/by-draft/:id");
        console.log("🧪 [fetchGuests] rows:", allGuests);


        setGuestCustomers(rebuiltAccompanying);

  
      } catch (error) {
        console.error("❌ Error cargando guests:", error);
      }
    };
  
    fetchGuests();
  }, [activeReservationId]); // ❌ fuera location.pathname
  

/*❌ DESACTIVADO — NO cargar reservas FINAL desde este hook
// La carga de datos base se hace por loaders específicos de DRAFT
// (/api/reservation-drafts/*)

  useEffect(() => {
      if (!activeReservationId) return;
  
      const loadReservationFromDB = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservations/${activeReservationId}`);
          const data = response.data;

          const freshFormData = {
            check_in_date: data.check_in_date || "",
            check_in_time: data.check_in_time || "",
            check_out_date: data.check_out_date || "",
            check_out_time: data.check_out_time || "",
            arrival_date: data.arrival_date || "",
            arrival_time: data.arrival_time || "",
            departure_date: data.departure_date || "",
            departure_time: data.departure_time || "",
            room_category_id: data.room_category_id || "",
            room_id: data.room_id || "",
            rate_id: data.rate_id || "",
            room_nights: data.room_nights || "",
            adults: data.adults || "",
            children: data.children || "",
            children_ages: (data.children_ages || []).join(","),
            babies: data.babies || 0,
            special_requests: data.special_requests || "",
            payment_status: data.payment_status || "Pending",
            total_price: data.total_price || "",
            created_by: data.created_by || "Admin",
            updated_by: data.updated_by || "",
            cancellation_reason: data.cancellation_reason || "",
            status: data.status || "Draft",
            business_unit_id: data.business_unit_id || 1,
            reservation_group_id: data.reservation_group_id || null,
            group_locator: data.group?.group_locator || null,
            group_total_rooms: data.group?.number_of_rooms || 1,
            group_rate_id: data.group_rate_id || null,
            group_rate_name: data.group_rate_name || "",
          };

          // ⬇️ Guardamos también extras y totales que devuelve el backend
          setFormData(prev => ({
            ...freshFormData,
            extras: data.extras || [],
            extras_details: data.extras_details || [],
            total_extras: data.total_extras || 0,
          }));

          console.log("📦 Recarga FORZADA desde DB → reserva", activeReservationId, freshFormData);
        } catch (err) {
          console.error("❌ Error recargando reserva desde DB:", err);
        }
      };
  
      loadReservationFromDB();
    }, [activeReservationId, location.pathname]); // ✅ se ejecuta solo al cambiar de Room
    */

    useEffect(() => {
        // 🔁 Limpieza del main guest cada vez que cambia de reserva activa
        setCustomerData(null);
      }, [activeReservationId]);
};
